import React from 'react';
import {AppTitle, AppText} from '../../../Presentation/components/ui/Typography';
import {useVisitTrends} from '../hooks/useVisits';
import VisitsTrendsCards from './VisitsTrendsCards';
import {BarChart3} from 'lucide-react';

interface VisitsAnalyticsProps {
  loading?: boolean;
}

const VisitsAnalytics: React.FC<VisitsAnalyticsProps> = ({
  loading = false
}) => {
  const {trends, loadingTrends, trendsError, fetchTrends} = useVisitTrends();

  // Fetch trends on component mount
  React.useEffect(() => {
    fetchTrends();
  }, [fetchTrends]);

  if (loading || loadingTrends) {
    return (
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="p-6 border border-gray-200 rounded-lg">
              <div className="animate-pulse">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
                <div className="h-3 bg-gray-200 rounded w-full"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (trendsError) {
    return (
      <div className="text-center py-12">
        <BarChart3 className="h-12 w-12 text-red-400 mx-auto mb-4" />
        <AppTitle className="text-red-600 mb-2">خطأ في تحميل التحليلات</AppTitle>
        <AppText className="text-gray-500">{trendsError}</AppText>
      </div>
    );
  }

  if (!trends) {
    return (
      <div className="text-center py-12">
        <BarChart3 className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <AppTitle className="text-gray-600 mb-2">لا توجد تحليلات متاحة</AppTitle>
        <AppText className="text-gray-500">جاري تحميل البيانات...</AppText>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Trends Data */}
      <VisitsTrendsCards trends={trends} loading={loadingTrends} />
    </div>
  );
};

export default VisitsAnalytics;
